var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fccFotoUser"},[_c('img',{staticClass:"user",attrs:{"src":_vm.documentoUser.usuariocomplemento.usucompfoto == null ||
      _vm.documentoUser.usuariocomplemento.usucompfoto === ''
        ? _vm.userIcon
        : _vm.documentoUser.usuariocomplemento.usucompfoto,"alt":"Foto"}}),_c('b-form-file',{ref:"input-candidato",attrs:{"placeholder":"Escolha um arquivo...","plain":"","accept":_vm.extPermitido.join()},on:{"input":function($event){return _vm.EnviarArquivo()}},model:{value:(_vm.file1),callback:function ($$v) {_vm.file1=$$v},expression:"file1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }